import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import EmergencyBar from "@/components/site/EmergencyBar";
import CookieConsent from "@/components/site/CookieConsent";
import PromoBanner from "@/components/site/PromoBanner";
import PromoModal from "@/components/site/PromoModal";
import GrandOpening from "@/pages/GrandOpening";
import AdminEnquiries from "@/pages/AdminEnquiries";
import LegacyRedirect from "@/components/site/LegacyRedirect";
import NewPatientExperience from "@/pages/NewPatientExperience";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

// Scroll to top on route change (preserve hash anchors for in-page nav). Cooperates with Lenis when active.
function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (!location.hash) {
      if (lenis) {
        lenis.scrollTo(0, { immediate: true });
      } else {
        window.scrollTo({ top: 0, behavior: "instant" });
      }
    } else {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        setTimeout(() => {
          if (lenis) {
            lenis.scrollTo(el, { offset: -80 });
          } else {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 60);
      }
    }
  }, [location.pathname, location.hash]);
  return null;
}

// Public website chrome. The staff dashboard renders bare, without marketing chrome.
function PublicSite() {
  return (
    <>
      <PromoBanner />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/grand-opening" element={<GrandOpening />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<LegacyRedirect><NotFound /></LegacyRedirect>} />
      </Routes>
      <Footer />
      <EmergencyBar />
      <CookieConsent />
      <PromoModal />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollManager />
        <div className="App min-h-screen">
          <Routes>
            <Route path="/admin/enquiries" element={<AdminEnquiries />} />
            <Route
              path="/new-patient-experience"
              element={
                <>
                  <NewPatientExperience />
                  <CookieConsent />
                </>
              }
            />
            <Route path="*" element={<PublicSite />} />
          </Routes>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#F5F0E8",
                color: "#3D2B1F",
                border: "1px solid rgba(61,43,31,0.15)",
                fontFamily: "Montserrat, sans-serif",
              },
            }}
          />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}
